const type = "SENSOR_TOTAL_CONSUMPTION/";

export const sensorTotalConsumptionConstants = {
  TOTAL_CONSUMPTION_REQUEST: `${type}TOTAL_CONSUMPTION_REQUEST`,
  TOTAL_CONSUMPTION_SUCCESS: `${type}TOTAL_CONSUMPTION_SUCCESS`,
  TOTAL_CONSUMPTION_FAILURE: `${type}TOTAL_CONSUMPTION_FAILURE`,
};
